import { render, staticRenderFns } from "./StudentMeasurement.vue?vue&type=template&id=473d2862&"
import script from "./StudentMeasurement.js?vue&type=script&lang=js&"
export * from "./StudentMeasurement.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports